import {MimeTypeMap} from "@/shared/mime_types";
import {LocalCache} from "@/shared/LocalCache";
import {getAskWyzeSttUrl, getAskWyzeTtsUrl} from "@/libwyze-shared/types";
import {SttRequest, SttResponse, TtsRequest, TtsResponse} from "../../libwyze-common/api/types";

export class Agent {

  private readonly cache = LocalCache.getInstance("agent_cache");

  async speechToText(url: string, cacheKey?: string): Promise<string> {
    let value: string;
    if (cacheKey && (value = this.cache.get(cacheKey))) {
      return value;
    }
    const result = await fetch(url);
    const blob = await result.blob();
    const reader = new FileReader();
    const encodedDataUrl: string = await new Promise((resolve, reject) => {
      reader.onloadend = (event) => {
        resolve(event.target.result as string);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(blob);
    });
    const encodedFile = encodedDataUrl.substring(encodedDataUrl.indexOf(",") + 1);
    const response = await fetch(getAskWyzeSttUrl(), {
      method: "POST",
      headers: {
        "Content-Type": MimeTypeMap.MimeType_application_json,
      },
      body: JSON.stringify({
        encodedFile,
      } as SttRequest),
    }).then(res => res.json()) as SttResponse;
    if (response.status.code !== 200) {
      throw new Error("Error fetching chat");
    }
    value = response.response.content.text;
    if (cacheKey) {
      this.cache.set(cacheKey, value);
    }
    return value;
  }

  async textToSpeech(text: string, cacheKey?: string): Promise<string> {
    let value: string;
    if (cacheKey && (value = this.cache.get(cacheKey))) {
      return value;
    }
    const response = await fetch(getAskWyzeTtsUrl(), {
      method: "POST",
      headers: {
        "Content-Type": MimeTypeMap.MimeType_application_json,
      },
      body: JSON.stringify({
        text,
      } as TtsRequest),
    }).then(res => res.json()) as TtsResponse;
    if (response.status.code !== 200) {
      throw new Error("Error fetching chat");
    }
    value = response.response.content.encodedFile;
    if (cacheKey) {
      this.cache.set(cacheKey, value);
    }
    return value;
  }
}